// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCovTgnFZ_nCnsXA1TNzZmMyGnAniYsMn8",
  authDomain: "keewebsite-680e5.firebaseapp.com",
  databaseURL: "https://keewebsite-680e5-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "keewebsite-680e5",
  storageBucket: "keewebsite-680e5.firebasestorage.app",
  messagingSenderId: "1061117068177",
  appId: "1:1061117068177:web:ae201c85619b276fbbd030"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const database = getDatabase(app);

export default app;
